module.exports = __webpack_public_path__ + "img/Process2-white.3ec487c0.svg";